import React from "react";
import styles from "./BrandLogo.module.css";

export const BRAND_LOGO_URL =
  "https://bhadapms-files.s3.ap-south-1.amazonaws.com/public/BhadaPMS_logo.png";

export interface BrandLogoProps {
  /**
   * Pixel width/height of the image. Defaults to 40.
   */
  size?: number;
  /**
   * Whether to render the "BhadaPMS" wordmark next to the image. Defaults to false.
   */
  showText?: boolean;
  /**
   * Class name applied to the root wrapper.
   */
  className?: string;
  /**
   * Class name applied directly to the `<img>` element.
   */
  imageClassName?: string;
  /**
   * Class name applied to the wordmark span.
   */
  textClassName?: string;
}

export function BrandLogo({
  size = 40,
  showText = false,
  className,
  imageClassName,
  textClassName,
}: BrandLogoProps) {
  return (
    <div className={`${styles.wrapper} ${showText ? styles.withText : styles.logoOnly} ${className || ""}`.trim()}>
      <img
        src={BRAND_LOGO_URL}
        alt="BhadaPMS Logo"
        loading="eager"
        width={size}
        height={size}
        className={`${styles.image} ${imageClassName || ""}`.trim()}
        style={{ width: size, height: size }}
      />
      {showText && (
        <span className={`${styles.text} ${textClassName || ""}`.trim()}>
          BhadaPMS
        </span>
      )}
    </div>
  );
}